import { useRecoilValue } from 'recoil'
import { Image } from 'antd'

import { authenticatedCustomerState } from 'src/data/customers/CustomersAtoms'
import { shopifyHomepage, shopifyHomepageStaging } from 'src/routes/NamedRoutes'
import { isFrench, isProduction } from 'src/utils/helper'

const BonLookLogo = (): JSX.Element => {
  const customer = useRecoilValue(authenticatedCustomerState)

  return (
    <a href={!isProduction() ? shopifyHomepageStaging(isFrench() ? 'fr' : 'en') : shopifyHomepage(customer.country, isFrench() ? 'fr' : 'en')}>
      <Image
        preview={false}
        width="auto"
        className="default-layout__logo"
        src={`${process.env.PUBLIC_URL}/images/Logo-BonLook-Noir.png`}
      />
    </a>
  )
}

export default BonLookLogo
